import App from './App';
import './assets/styles/index.scss';
import './filters/capitalize';
import './plugins/clipper';
import './plugins/googleMaps';
import vuetify from './plugins/vuetify';
import registerComponents from './registerComponents';
import router from './router';
import cookieService from './services/cookieService';
import store from './store';
import Vue from 'vue';
import VueCookies from 'vue-cookies';

registerComponents();

Vue.use(VueCookies);

const app = new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
  methods: {
    initializeConsentPreferences() {
      cookieService.reloadVendors();
    },
  },
  mounted() {
    this.initializeConsentPreferences();
  },
}).$mount('#app');

export default app;
